import validator from 'validator'

import type { IdValidationStrategy } from 'modules/legal_entities/lib/types'

import validatePortugueseIdCard from './idCardValidator'
import { PortugalIdType } from './idType'
import validatePortugalSsn from './ssnValidator'
import validatePortugalTaxId from './taxIdValidator'

class PortugalIdValidationStrategy implements IdValidationStrategy {
  constructor(private idType: PortugalIdType, private id: string, private idLabel: string) {}

  isValid(): boolean {
    if (this.disabled()) return true

    switch (this.idType) {
      case PortugalIdType.SocialSecurityNumber:
        return validatePortugalSsn(this.id)
      case PortugalIdType.TaxId:
        return validatePortugalTaxId(this.id)
      case PortugalIdType.Passport:
        return validator.isPassportNumber(this.id, 'PT')
      case PortugalIdType.IdCard:
        return validatePortugueseIdCard(this.id)
      case PortugalIdType.ResidenceCard:
        return true
      default:
        return false
    }
  }

  errors(): string {
    if (!this.isValid()) {
      return `Invalid ${this.idLabel} number`
    }
    return ''
  }

  disabled(): boolean {
    return PortugalIdType.Passport == this.idType
  }
}

export default PortugalIdValidationStrategy
